// src/pages/NotFound.tsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate from React Router
import "./notFound.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate(); // Initialize navigate function
  const location = useLocation(); // Get current location
  const [refreshAttempted, setRefreshAttempted] = useState(false);

  useEffect(() => {
    // Auto-refresh once if we haven't tried yet
    // This helps when the route exists but wasn't matched on first load
    if (!refreshAttempted) {
      setRefreshAttempted(true);
      // Small delay to ensure the component is fully rendered
      const timer = setTimeout(() => {
        // Reload the page to give the server a chance to serve index.html
        window.location.reload();
      }, 1000); // Increased delay to 1 second for better UX
      return () => clearTimeout(timer);
    }
  }, [refreshAttempted, location.pathname]);

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div className="not-found-page">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <p>Refreshing page...</p>
      <button onClick={handleGoBack}>Go Back</button>
    </div>
  );
};

export default NotFound;
